import React from "react";
import { Card, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { MutantApiService } from "../../../../services/MutantApiService";
import IsEqualPassword from "../../../../utils/validators/IsEqualPassword";
import IsValidName from "../../../../utils/validators/IsValidName";
import Loading from "../../../home/components/Loading";
import { StyledCardBody } from "../../components/AdminCard/style";
import { AdminTitle } from "../../components/AdminTitle";
import FormActions from "../../components/FormActions";
import { InputField } from "../../components/InputField";
import { withRouter } from "react-router-dom";


import store from "../../../../store/store";


export class ProjectsForm extends React.Component {
	constructor(props) {
		super(props);

		const { auth } = store.getState();
		this.initialState = {
			id: 0,
			name: "",
			description: "",
			isLoading: false,
			isEditing: false,
			userLogged: auth.user,
			isEdit: false,};
		this.state = {
			id: 0,
			name: "",
			description: "",
			isLoading: false,
			isEditing: false,
			userLogged: auth.user,
			isEdit: false,
		};

		this.api = new MutantApiService();

		this.handleChange = this.handleChange.bind(this);
		this.onCleanForm = this.onCleanForm.bind(this);
		this.submit = this.submit.bind(this);
	}

	async componentDidMount() {
		const isEditing = !!this.props.match.params.id;
		this.setState({ isLoading: true, isEditing });
		try {
			if (this.props.match.params.id) {
				await this.loadProject(this.props.match.params.id);
			}
		} catch (error) {
			await Swal.fire(
				"Erro!",
				"Ocorreu um erro ao carregar os dados, tente novamente mais tarde!",
				"error"
			);
		}


		this.setState({ isLoading: false });
	}

	loadProject = async id => {
		const project = await this.api.makeHttpRequest({
			url: `/projects/${id}`
		});

		this.setState({
			id: id,
			name: project.name,
			description: project.description,
			isLoading: false,
			isEdit: true
		});
	};

	submit = async e => {
		e.preventDefault();
		const valid = IsEqualPassword(
			this.state.password,
			this.state.confirmPassword
		);

		if (!valid.isValid) {
			await Swal.fire("Erro", valid.error, "error");
			return;
		}

		const id = this.props.match.params.id;
		this.setState({ isLoading: true });
		try {
			const reqBase = id
				? { method: "PATCH", url: `/projects/${id}` }
				: { method: "POST", url: "/projects" };

			await this.api.makeHttpRequest({
				...reqBase,
				data: {
					name: this.state.name,
					description: this.state.description,
					idUser: 0
				}
			});

			this.afterSubmit();
		} catch (e) {
			Swal.fire(
				"Erro!",
				e?.response?.data
					? e.response.data.message
					: "Erro ao cadastrar cliente, tente novamente mais tarde.",
				"error"
			);
		}

		this.setState({ isLoading: false });
	};

	afterSubmit = async () => {
		this.setState({
			...this.initialState,
			resetInput: true
		});

		const { isEditing } = this.state;

		const { value } = await Swal.fire({
			title: "Sucesso!",
			text: "Dados salvos com sucesso.",
			icon: "success",
			showCancelButton: !isEditing,
			confirmButtonText: isEditing ? "Ok" : "Novo cadastro",
			cancelButtonText: "Sair"
		});

		console.log("VALUE", value)
		if (value) {
			this.state = {
				...this.initialState,
				resetInput: true
			}
		}
		if (!value || isEditing) {
			setTimeout(() => this.props.history.push("/dashboard/projects"), 100);
		}
		
	};

	handleChange = e => {
		this.setState({
			[e.target.name]: e.target.value
		});
	};

	formIsValid = () => {
		return (
			this.state.name &&
			IsValidName(this.state.name) &&
			this.state.description &&
			this.state.description.length > 5
		);
	};

	onCleanForm = async () => {
		if (this.props.match.params.id) {
			this.setState({ isLoading: true });

			try {
				await this.loadProject(this.props.match.params.id);
			} catch (e) {
				await Swal.fire(
					"Erro",
					"Problema ao reverter as alterações, tente mais tarde",
					"error"
				);
			}

			this.setState({ isLoading: false });
		} else {
			this.setState({
				...this.initialState,
				resetInput: true
			});
		}
	};

	render() {
		if (this.state.isEditing) {
			window.setPageTitle("Atualizar Projeto - Admin");
		} else {
			window.setPageTitle("Cadastro de Projeto - Admin");
		}

		const {
			name,
			description,
			isLoading,
			isEditing,
		} = this.state;

		return (
			<>
				<Loading isLoading={isLoading} />
				<AdminTitle title="Dados do Projeto" disableHeader />
				<Card className="mt-4">
					<StyledCardBody>
						<Form style={{ flex: "1" }}>
							{/* row 1 */}
							<Form.Row>
								{/* Nome */}
								<Form.Group as={Col} lg="6" xs="12">
									<InputField
										type="text"
										name="name"
										label="Nome"
										placeholder="Digite o nome"
										value={name}
										onChange={this.handleChange}
										isInvalid={name && !IsValidName(name)}
										required
									/>
								</Form.Group>

								{/* Descrição */}
								<Form.Group as={Col} lg="6" xs="12">
									<InputField
										type="text"
										name="description"
										label="Descrição"
										placeholder="Digite a descrição"
										value={description}
										onChange={this.handleChange}
										isInvalid={description && description.length < 5}
										required
									/>
								</Form.Group>
							</Form.Row>
						</Form>
					</StyledCardBody>
				</Card>
				<FormActions
					module="projects"
					isEdit={isEditing}
					formIsValid={this.formIsValid()}
					onCleanForm={this.onCleanForm}
					onSubmit={this.submit}
					hideReload
				/>
			</>
		);
	}
}

export default withRouter(ProjectsForm);

